module.exports = __webpack_public_path__ + "img/25.f40f9d3a.png";